module.exports = __webpack_public_path__ + "img/vip.64370694.png";